export enum PreferredChannelEnum {
  TEXT_MESSAGE = 'TEXT_MESSAGE',
  PHONE = 'PHONE',
  EMAIL = 'EMAIL'
}
